
import { useTranslation } from 'react-i18next';

export default function WhyChooseUsSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('why.title')}
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-[#F97316] rounded-2xl p-12 text-white shadow-xl">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('why.security.title')}</h3>
                  <p className="text-white/90">{t('why.security.desc')}</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-time-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('why.delivery.title')}</h3>
                  <p className="text-white/90">{t('why.delivery.desc')}</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-settings-3-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('why.operation.title')}</h3>
                  <p className="text-white/90">{t('why.operation.desc')}</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-customer-service-2-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('why.support.title')}</h3>
                  <p className="text-white/90">{t('why.support.desc')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
